module.exports = __webpack_public_path__ + "img/GAME_SEAOFFANTASY.71ae727d.png";